var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"id":_vm.inputId,"label":_vm.inputLabel,"prepend-icon":"filter_1","disabled":_vm.campoDesabilitado,"required":_vm.campoObrigatorio,"rules":[_vm.rules.requiredNome, _vm.rules.numeroValido, _vm.rules.intervaloValido],"type":"Number"},on:{"input":_vm.numeroAlterado},model:{value:(_vm.valorInterno),callback:function ($$v) {_vm.valorInterno=$$v},expression:"valorInterno"}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/shared-components/metadados/campos-dinamicos/MetadadosCampoDinamicoNumerico.vue?vue&type=template&id=56c10616&
// module id = 1347
// module chunks = 28